// import { useCallback, useEffect, useState } from "react";

// import { useGlobalContext } from "../Context/GlobalContext";

// export const useDriverTrackerStatus = (taskId) => {
//   const { packkyApi } = useGlobalContext();

//   const [driverStatus, setDriverStatus] = useState(undefined);
//   const [merchantStatus, setMerchantStatus] = useState(undefined);

//   // =====================================================
//   // GET DRIVER TRACKER STATUS
//   // =====================================================

//   const fetchTrackerStatus = useCallback(async () => {
//     if (!taskId) {
//       setDriverStatus(undefined);
//       setMerchantStatus(undefined);
//       return null;
//     }

//     try {
//       const payload = {
//         taskId: String(taskId),
//       };

//       const res = await packkyApi.post(
//         "/api/DriverTracker/v1.0/getDriverTrackerStatus",
//         payload,
//       );

//       if (res?.data?.responseCode !== "00") {
//         return res?.data;
//       }

//       const row = res?.data?.data?.[0];

//       if (!row) {
//         return res?.data;
//       }

//       const rawStatus = row?.status?.toLowerCase()?.trim();

//       const rawMerchant = row?.merchant_order_status?.toLowerCase()?.trim();

//       let mappedDriverStatus;
//       let mappedMerchantStatus;

//       // =====================================================
//       // DRIVER STATUS MAPPING
//       // =====================================================

//       if (
//         [
//           "assigned",
//           "acknowledged",
//           "arrived",
//           "picked up",
//           "successful",
//         ].includes(rawStatus)
//       ) {
//         mappedDriverStatus = rawStatus;
//       }

//       // SPECIAL CASE
//       if (rawStatus === "food is ready") {
//         mappedDriverStatus = "acknowledged";
//       }

//       // =====================================================
//       // MERCHANT STATUS MAPPING
//       // =====================================================

//       if (rawMerchant) {
//         mappedMerchantStatus = rawMerchant;
//       }

//       // fallback
//       if (!mappedMerchantStatus && rawStatus === "food is ready") {
//         mappedMerchantStatus = "food is ready";
//       }

//       console.log("TRACKER STATUS MAPPED:", {
//         rawStatus,
//         rawMerchant,
//         mappedDriverStatus,
//         mappedMerchantStatus,
//       });

//       setDriverStatus(mappedDriverStatus);

//       setMerchantStatus(mappedMerchantStatus);

//       return res?.data;
//     } catch (error) {
//       console.error("GET DRIVER TRACKER STATUS ERROR:", error);

//       return null;
//     }
//   }, [taskId, packkyApi]);

//   // =====================================================
//   // FIRST LOAD
//   // =====================================================

//   useEffect(() => {
//     if (!taskId) {
//       return;
//     }

//     fetchTrackerStatus();
//   }, [taskId, fetchTrackerStatus]);

//   // =====================================================
//   // RETURN
//   // =====================================================

//   return {
//     driverStatus,
//     merchantStatus,
//     refetchStatus: fetchTrackerStatus,
//   };
// };

import { useCallback, useEffect, useRef, useState } from "react";

import { useGlobalContext } from "../Context/GlobalContext";

export const useDriverTrackerStatus = (taskId) => {
  const { packkyApi } = useGlobalContext();

  const [driverStatus, setDriverStatus] = useState(undefined);

  const [merchantStatus, setMerchantStatus] = useState(undefined);

  // Same task ke liye initial API dobara call nahi hogi
  const initialFetchedTaskRef = useRef(null);

  // =====================================================
  // GET DRIVER TRACKER STATUS
  // =====================================================

  const fetchTrackerStatus = useCallback(async () => {
    if (!taskId) {
      setDriverStatus(undefined);
      setMerchantStatus(undefined);

      return null;
    }

    try {
      const payload = {
        taskId: String(taskId),
      };

      console.log("GET DRIVER TRACKER STATUS CALL:", payload);

      const res = await packkyApi.post(
        "/api/DriverTracker/v1.0/getDriverTrackerStatus",
        payload,
      );

      if (res?.data?.responseCode !== "00") {
        return res?.data;
      }

      const row = res?.data?.data?.[0];

      if (!row) {
        return res?.data;
      }

      const rawStatus = row?.status?.toLowerCase()?.trim();

      const rawMerchant = row?.merchant_order_status?.toLowerCase()?.trim();

      let mappedDriverStatus;
      let mappedMerchantStatus;

      // =====================================================
      // DRIVER STATUS
      // =====================================================

      if (
        [
          "assigned",
          "acknowledged",
          "arrived",
          "picked up",
          "successful",
        ].includes(rawStatus)
      ) {
        mappedDriverStatus = rawStatus;
      }

      if (rawStatus === "food is ready") {
        mappedDriverStatus = "acknowledged";
      }

      // =====================================================
      // MERCHANT STATUS
      // =====================================================

      if (rawMerchant) {
        mappedMerchantStatus = rawMerchant;
      }

      if (!mappedMerchantStatus && rawStatus === "food is ready") {
        mappedMerchantStatus = "food is ready";
      }

      console.log("TRACKER STATUS MAPPED:", {
        rawStatus,
        rawMerchant,
        mappedDriverStatus,
        mappedMerchantStatus,
      });

      setDriverStatus(mappedDriverStatus);

      setMerchantStatus(mappedMerchantStatus);

      return res?.data;
    } catch (error) {
      console.error("GET DRIVER TRACKER STATUS ERROR:", error);

      return null;
    }
  }, [taskId, packkyApi]);

  // =====================================================
  // INITIAL CALL - ONLY ONCE PER TASK ID
  // =====================================================

  useEffect(() => {
    if (!taskId) {
      return;
    }

    const currentTaskId = String(taskId);

    if (initialFetchedTaskRef.current === currentTaskId) {
      return;
    }

    initialFetchedTaskRef.current = currentTaskId;

    fetchTrackerStatus();
  }, [taskId, fetchTrackerStatus]);

  // =====================================================
  // RETURN
  // =====================================================

  return {
    driverStatus,
    merchantStatus,

    // SignalR status change ke time manually
    // call kar sakte ho
    refetchStatus: fetchTrackerStatus,
  };
};